import React, { KeyboardEvent } from 'react';
import { useDispatch } from 'react-redux';
import { actionCreators } from '../../store';
import { Language } from '../../enums';
import { TRANSLATIONS } from '../../constants';
import { useTranslate } from '../../hooks/common';
import HeaderAction, { HeaderActionProps, HeaderDropdownAction } from './HeaderAction';
import ContentContainer from '../common/ContentContainer';
import { IconType } from '../common/Icon';
import siemensLogo from '../../../assets/images/siemens-logos/siemens-logo-petrol.svg';

type LanguageType = 'en' | 'de';

interface HeaderProps {
    title?: string;
}

const Header = ({ title }: HeaderProps) => {
    const dispatch = useDispatch();
    const translate = useTranslate();
    const languages = Object.keys(Language).slice(0, Math.ceil(Object.keys(Language).length / 2)).map(x => Number(x));

    const handleSkipButtonKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();

            location.hash = '';
            location.hash = '#main';
        }
    };

    const setLanguage = (language: Language) => {
        dispatch(actionCreators.setLanguage(language));
        window.localStorage.setItem('language', language.toString());
    };
    
    const headerActions: HeaderActionProps[] = [
        {
            dropdownActions: languages.map<HeaderDropdownAction>(x => ({ name: translate(TRANSLATIONS.header.languages[Language[x].toLowerCase() as LanguageType]), onClick: () => setLanguage(x) })),
            iconType: IconType.Language,
            title: translate(TRANSLATIONS.header.language)
        },
        {
            dropdownActions: [{ name: translate(TRANSLATIONS.header.reportProblem), iconType: IconType.Email, onClick: () => window.location.href = 'mailto:apps-help.industry@siemens.com' }],
            iconType: IconType.Support,
            title: translate(TRANSLATIONS.header.support)
        }
    ];

    return (
        <header>
            <div className='main-row-container'>
                <ContentContainer header>
                    <div className='main-row'>
                        <div className='skip-button' tabIndex={0} onKeyDown={handleSkipButtonKeyDown}>
                            {translate(TRANSLATIONS.header.skipToMainContent)}
                        </div>
                        <div className='header-row-container'>
                            <img className='siemens-logo' src={siemensLogo} alt='Siemens Logo' />
                        </div>
                        {title &&
                            <div className='header-row-container'>
                                <div className='title'></div>
                            </div>
                        }
                        <div className='action-container'>
                            {headerActions.map(x => <HeaderAction key={x.title} dropdownActions={x.dropdownActions} iconType={x.iconType} title={x.title} />)}
                        </div>
                    </div>
                </ContentContainer>
            </div>
        </header>
    );
};

export default Header;
